import shallow from "zustand/shallow";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { useReactQuery } from "components/RemoteData";

import { useGetAuthorizationStore } from "./useGetAuthorizationStore";
import { getUser, getUserKey } from "../../user/infrastructure/useGetUser";

export const useIsUserLogged = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const { tokenSecurity, userId } = useGetAuthorizationStore(
    (state) => ({
      tokenSecurity: state.tokenSecurity,
      userId: state.userId,
      deleteAuthorization: state.deleteAuthorization,
      setAuthorization: state.setAuthorization,
    }),
    shallow
  );

  const { error, data } = useReactQuery(
    getUserKey(userId, tokenSecurity),
    () => getUser(friendlyUrl, tokenSecurity, userId),
    {
      suspense: false,
    }
  );

  return !(!data || error);
};
